/* global System */
// register component(s) with react habitat

export default { PraxisWissen: () => System.import('./index') }
